import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import shippingService from "../../services/shippingService";

export const fetchShipping=createAsyncThunk(
    "shipping/fetch",
    async()=>{

        return await shippingService.getShipping();

    }
);

export const removeShipping=createAsyncThunk(
    "shipping/delete",
    async(id)=>{

        await shippingService.deleteShipping(id);

        return id;

    }
);

export const addShipping = createAsyncThunk(
    "shipping/add",
    async (formData, thunkAPI) => {
        try {
            return await shippingService.addShipping(formData);
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message
            );
        }
    }
);

const shippingSlice=createSlice({

    name:"shipping",

    initialState:{
        shipping:[],
        loading:false
    },

    reducers:{},

    extraReducers:(builder)=>{

        builder

.addCase(fetchShipping.pending,(state)=>{
    state.loading=true;
})

.addCase(fetchShipping.fulfilled,(state,action)=>{
    state.loading=false;
    state.shipping=action.payload;
})

.addCase(fetchShipping.rejected,(state)=>{
    state.loading=false;
})

.addCase(addShipping.fulfilled,(state,action)=>{

    state.shipping.unshift(action.payload);

})

.addCase(removeShipping.fulfilled,(state,action)=>{

    state.shipping=
    state.shipping.filter(
        x=>x._id!==action.payload
    );

});

    }

});

export default shippingSlice.reducer;